// Shared navigation config used by Sidebar.jsx and CommandPalette.jsx
import {
  Home, Search, Briefcase, Kanban, Bookmark, Bell, Globe, TrendingUp, GraduationCap,
  Sparkles, FileText, Mic, Video, ClipboardCheck, BarChart3, DollarSign, Target,
  Building2, MessageSquare, Users, User, Award, Gift, Settings, LayoutDashboard,
  Plus, UserCheck, Mail, Send, Calendar, ShoppingBag, Shield, Activity, CreditCard,
  Flag, FlaskConical, MailOpen, Database, Download, Wrench, Eye, PenSquare, Zap
} from "lucide-react";

export const jobseekerNav = [
  {
    id: "overview", label: "Overview", icon: Home,
    items: [
      { path: "/dashboard/jobseeker", label: "Dashboard", icon: LayoutDashboard },
      { path: "/for-you", label: "For You", icon: Sparkles },
      { path: "/notifications", label: "Notifications", icon: Bell },
    ]
  },
  {
    id: "jobs", label: "Jobs", icon: Search,
    items: [
      { path: "/jobs", label: "Browse Jobs", icon: Search, exact: true },
      { path: "/my-applications", label: "My Applications", icon: Briefcase },
      { path: "/applications", label: "Application Tracker", icon: Kanban },
      { path: "/jobs/saved", label: "Saved Jobs", icon: Bookmark },
      { path: "/jobs/alerts", label: "Job Alerts", icon: Bell },
      { path: "/external-jobs", label: "External Jobs", icon: Globe },
      { path: "/trending", label: "Trending", icon: TrendingUp },
    ]
  },
  {
    id: "career", label: "Career Tools", icon: GraduationCap,
    items: [
      { path: "/cv-builder", label: "CV Builder", icon: Sparkles },
      { path: "/resume-optimization", label: "Resume Optimizer", icon: FileText },
      { path: "/interview-prep", label: "Interview Prep", icon: Mic },
      { path: "/interviews", label: "My Interviews", icon: Video },
      { path: "/recordings", label: "Recordings", icon: Video },
      { path: "/assessments", label: "Assessments", icon: ClipboardCheck },
    ]
  },
  {
    id: "insights", label: "Insights", icon: BarChart3,
    items: [
      { path: "/career-insights", label: "Career Insights", icon: TrendingUp },
      { path: "/salary-research", label: "Salary Research", icon: DollarSign },
      { path: "/jobseeker/market-insights", label: "Market Trends", icon: Target },
      { path: "/companies", label: "Companies", icon: Building2 },
      { path: "/analytics/advanced", label: "Analytics", icon: BarChart3 },
    ]
  },
  {
    id: "connect", label: "Connect", icon: MessageSquare,
    items: [
      { path: "/messages", label: "Messages", icon: MessageSquare, hasBadge: true },
      { path: "/community", label: "Community", icon: Users },
      { path: "/search/users", label: "Find People", icon: Search },
    ]
  },
  {
    id: "account", label: "Account", icon: User,
    items: [
      { path: "/profile/build", label: "My Profile", icon: User },
      { path: "/badges", label: "Badges", icon: Award },
      { path: "/referral", label: "Refer & Earn", icon: Gift },
      { path: "/settings", label: "Settings", icon: Settings },
    ]
  },
];

export const recruiterNav = [
  {
    id: "overview", label: "Overview", icon: Home,
    items: [
      { path: "/dashboard/recruiter", label: "Dashboard", icon: LayoutDashboard },
      { path: "/for-you", label: "For You", icon: Sparkles },
      { path: "/notifications", label: "Notifications", icon: Bell },
    ]
  },
  {
    id: "hiring", label: "Hiring", icon: Briefcase,
    items: [
      { path: "/jobs/create", label: "Post a Job", icon: Plus },
      { path: "/jobs/manage", label: "Manage Jobs", icon: Briefcase },
      { path: "/applicant-pipeline", label: "Pipeline", icon: UserCheck },
      { path: "/candidates", label: "Candidate Search", icon: Search, exact: true },
      { path: "/candidates/compare", label: "Compare Candidates", icon: Users },
    ]
  },
  {
    id: "outreach", label: "Outreach", icon: Mail,
    items: [
      { path: "/messages", label: "Messages", icon: MessageSquare, hasBadge: true },
      { path: "/bulk-messaging", label: "Bulk Messaging", icon: Send },
      { path: "/crm", label: "CRM", icon: Users },
      { path: "/search/users", label: "Find People", icon: Search },
    ]
  },
  {
    id: "interviews", label: "Interviews", icon: Video,
    items: [
      { path: "/interviews", label: "Scheduled", icon: Video },
      { path: "/recordings", label: "Recordings", icon: Video },
      { path: "/calendar", label: "Calendar", icon: Calendar },
    ]
  },
  {
    id: "insights", label: "Insights", icon: BarChart3,
    items: [
      { path: "/analytics/recruiter", label: "Analytics", icon: BarChart3 },
      { path: "/community", label: "Community", icon: Users },
    ]
  },
  {
    id: "account", label: "Account", icon: User,
    items: [
      { path: "/profile/recruiter", label: "Company Profile", icon: Building2 },
      { path: "/addons", label: "Add-ons & Credits", icon: ShoppingBag },
      { path: "/badges", label: "Badges", icon: Award },
      { path: "/referral", label: "Refer & Earn", icon: Gift },
      { path: "/settings", label: "Settings", icon: Settings },
    ]
  },
];

export const adminNav = [
  {
    id: "overview", label: "Overview", icon: LayoutDashboard,
    items: [
      { path: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
      { path: "/admin/activity", label: "Activity Logs", icon: Activity },
    ]
  },
  {
    id: "users", label: "Users & Access", icon: Users,
    items: [
      { path: "/admin/users", label: "User Management", icon: Users },
      { path: "/admin/ambassadors", label: "Ambassadors", icon: Gift },
      { path: "/admin/subscriptions", label: "Subscriptions", icon: CreditCard },
    ]
  },
  {
    id: "content", label: "Content", icon: Briefcase,
    items: [
      { path: "/admin/jobs", label: "Job Management", icon: Briefcase },
      { path: "/admin/moderation", label: "Moderation", icon: Flag },
      { path: "/admin/notifications", label: "Broadcasts", icon: Bell },
    ]
  },
  {
    id: "analytics", label: "Analytics", icon: BarChart3,
    items: [
      { path: "/admin/analytics", label: "Platform Analytics", icon: BarChart3 },
      { path: "/admin/revenue", label: "Revenue", icon: DollarSign },
      { path: "/admin/email-analytics", label: "Email Analytics", icon: MailOpen },
      { path: "/admin/experiments", label: "A/B Testing", icon: FlaskConical },
      { path: "/admin/growth", label: "Growth Tools", icon: TrendingUp },
    ]
  },
  {
    id: "tools", label: "Tools", icon: Wrench,
    items: [
      { path: "/admin/bulk", label: "Bulk Management", icon: Database },
      { path: "/admin/export", label: "Data Export", icon: Download },
      { path: "/admin/settings", label: "Settings", icon: Settings },
    ]
  },
];

export const quickActions = {
  jobseeker: [
    { label: "Browse Jobs", path: "/jobs", icon: Search },
    { label: "Applications", path: "/my-applications", icon: Eye },
    { label: "Update Profile", path: "/profile/build", icon: PenSquare },
  ],
  recruiter: [
    { label: "Post a Job", path: "/jobs/create", icon: Plus },
    { label: "Shortlisting", path: "/dashboard/recruiter", icon: Zap },
    { label: "Send Invite", path: "/interviews", icon: Mail },
  ],
  admin: [
    { label: "Manage Users", path: "/admin/users", icon: Users },
    { label: "Analytics", path: "/admin/analytics", icon: Eye },
    { label: "Subscriptions", path: "/admin/subscriptions", icon: CreditCard },
  ],
};

export function getNavForRole(role) {
  if (role === "admin") return adminNav;
  if (role === "recruiter") return recruiterNav;
  return jobseekerNav;
}
